import axios from 'axios'

export default {
    get: () => axios.get('providers'),
    store: (data) => axios.post('providers/store', data),
    update: (data) => axios.post('providers/update', data),
    delete: (id) => axios.post('providers/delete', id)
}